import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Collection from './Collection';
import Core from './Core';
import Delivery from './Delivery';
import Notes from './Notes';
import Transport from './Transport';

const PurchaseOrderForm = forwardRef(({order, fields = 'core', onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  const getFields = useCallback(() => {
    switch (fields) {
      case 'collection':
        return Collection;
      case 'delivery':
        return Delivery;
      case 'notes':
        return Notes;
      case 'transport':
        return Transport;
      case 'core':
      default:
        return Core;
    }
  }, [fields]);

  return (
    <BaseForm
      ref={formRef}
      entity={order}
      type="order"
      fieldsComponent={useCallback((props) => {
        const Fields = getFields();
        return <Fields {...props}/>
      }, [getFields])}
      onSave={useCallback((data) => (
        services.purchaseOrder.saveOrder({...(order?.id ? {id: order.id} : {}), ...getFields().onSave(data)})
      ), [order, services, getFields])}
      onSaved={onSaved}
    />
  );
});

export default PurchaseOrderForm;
